<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              width="140px"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="emailTitle"
              max-length="100"
              default
              style="width: 100%"
              :readonly="isTitleReadonly"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RCPT_USR')"
              width="140px"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-11">
            <div
              class="width100"
              style="flex-direction:row"
            >
              <div class="dp_flex mrB05">
                <cmp-user-select
                  :selectedUser="selectedUser"
                  :emailUser="true"
                  @selected="onSelectedUser"
                />
                <div class="comp_spacing" />
                <sui-checkbox
                  v-model="writeTomeCheck"
                  style="margin-left:auto;width:120px"
                  @input="onCheck"
                >
                  {{ $t('MSG_TXT_WRITE_TO_ME') }}
                </sui-checkbox>
              </div>
              <cmp-email-recipients-list
                ref="emailRecipients"
                :pageId="contextPageId"
                :recptDispFormat="no10_recptDispFormat"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RSV_SEND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-checkbox
              v-model="rsvSendCheck"
              style="width:40px"
            />
            <div class="comp_spacing2" />
            <sui-date-picker
              ref="rsvSendDate"
              v-model="rsvSendDate"
              :disabled-dates="disabledDatePicker"
              :disabled="rsvSendCheckYn"
              @confirm="onConfirmDatePicker"
            />
            <div class="comp_spacing" />
            <sui-time-picker
              ref="rsvSendTime"
              v-model="rsvSendTime"
              format="HH:mm"
              :disabled="rsvSendCheckYn"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_FILE')"
              width="140px"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <cmp-file-attacher
              ref="fileAttacher"
              :pageId="contextPageId"
              :showDDRegion="false"
              :attachGroupId="attachGroupId"
              :attachDocumentId="attachDocumentId"
              class="width100"
              :deletableOld="isTransFileModify"
              :disabled="isfileDisabled"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CNTN')"
              width="140px"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-11">
            <sui-web-editor
              ref="tuiEditor"
              :isViewer="isEditorViewerMode"
              class="width100"
              @loaded="editorInitCallback"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div
        v-if="isThisWindowPopup"
        class="comm_btn_wrap"
      >
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t("MSG_BTN_CANCEL") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border_Prime"
          @click="onSend('tmpRegister')"
        >
          {{ $t("MSG_BTN_TMP_SAVE") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSend('register')"
        >
          {{ $t("MSG_TXT_SEND") }}
        </sui-button>
      </div>
    </sui-page-contents>
    <sui-page-footer
      v-if="isThisLayerPopup"
    >
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t("MSG_BTN_CANCEL") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border_Prime"
          @click="onSend('tmpRegister')"
        >
          {{ $t("MSG_BTN_TMP_SAVE") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSend('register')"
        >
          {{ $t("MSG_TXT_SEND") }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const codeKeys = ['COD_EMAIL_RECP_USR_TYPE'];
/* eslint max-len: ["error", { "code": 200 }] */
export default {
  name: 'PGE_CMM_00004', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      maxContentsSize: 0,
      isEditorViewerMode: false,
      isfileDisabled: false,
      isTransFileModify: false,
      isTitleReadonly: false,
      isReceiverDisabled: false,
      attachGroupId: 'ATG_CMM_MAIL_COMMON',
      attachDocumentId: '',
      selectedUser: {
        userName: '',
        email: '',
        companyName: '',
        departmentName: '',
        dsplLngId: '',
      },
      codes: {
        COD_EMAIL_RECP_USR_TYPE: [{ label: '', key: '' }],
      },
      // eslint-disable-next-line no-template-curly-in-string
      // no10_recptDispFormat: '${userName}/${deptNm}/${cpnyNm} [${email}]',
      no10_recptDispFormat: '${userName}/${departmentName}/${companyName} [${email}]',
      emailTitle: '',
      writeTomeCheck: false,
      isWebEditorContentsHtml: false,
      newDococumentId: '',
      rsvSendDate: moment().add(0, 'year').format(),
      disabledDatePicker: `${moment().add(10, 'year').format('YYYY-12-31')}~${moment().add(0, 'year').format('YYYY-MM-DD')}`,
      rsvSendTime: {
        HH: '12',
        mm: '00',
      },
      rsvSendCheck: false,
      isThisLayerPopup: this.closePagePopup !== null,
      isThisWindowPopup: this.closePagePopup === null,
    };
  },
  computed: {
    // 계산된 속성, property로 사용가능
    // isEditor() {
    //   return this.pageInitialData.Editor;
    // },
    rsvSendCheckYn() {
      return utils.isEqual(this.rsvSendCheck, false);
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    editorInitCallback() {
      // DOM이 document에 append된 상태, 실제 element에 접근 가능 (this.$el or this.$refs)
      // 주로 데이터 패치 등을 함
      this.loadCode().then(() => {
        this.loadData();
      });
    },
    loadCode() {
      return http.mergeCodeList(this.contextPageId, codeKeys, this.codes).then(() => {
      }).catch(error => {
        console.log(error);
      });
    },
    loadData() {
      if (!this.isThisWindowPopup) {
        if (this.pageInitialData !== null) {
          const has = Object.prototype.hasOwnProperty;

          this.emailTitle = this.pageInitialData.mailTitle;
          // 제목 수정여부 세팅
          if (has.call(this.pageInitialData, 'titleReadonly')) {
            // 제목 수정가능여부 값이 null 인경우 - 기본적으로 수정가능.
            if (this.pageInitialData.titleReadonly === null || utils.isEmpty(this.pageInitialData.titleReadonly)) {
              this.isTitleReadonly = false;
            } else if (this.pageInitialData.titleReadonly === true) {
              this.isTitleReadonly = true;
            } else {
              this.isTitleReadonly = false;
            }
          } else {
            this.isTitleReadonly = false;
          }

          // 수신자 변경 가능여부  (디폴트 : 변경불가, Null인 경우 디폴트 값으로 셋팅)
          if (has.call(this.pageInitialData, 'receiverModify')) {
            if (this.pageInitialData.receiverModify === null || utils.isEmpty(this.pageInitialData.receiverModify)) this.isReceiverDisabled = 'false';
            else if (this.pageInitialData.receiverModify === true) this.isReceiverDisabled = 'false';
            else this.isReceiverDisabled = 'true';
          } else {
            this.isReceiverDisabled = 'true';
          }

          // 수신자 세팅.
          if (this.pageInitialData.mailList !== undefined && this.pageInitialData.mailList[0].userId !== undefined) {
            this.pageInitialData.mailList.forEach(data => {
              utils.set(data, 'disFlag', false);
              this.$refs.emailRecipients.addRecipient(data);
            });
          }

          if (has.call(this.pageInitialData, 'attachDocumentId')) {
            if (this.pageInitialData.moduleCode !== null
              || !utils.isEmpty(this.pageInitialData.moduleCode)) {
              const attachParam = {
                attachGroupId: 'ATG_CMM_MAIL_COMMON',
                attachItemId: 'ATG_CMM_MAIL_COMMON_00001',
                attachDocumentTypeCode: 'N',
                moduleCode: this.pageInitialData.moduleCode,
                attachDocumentIdList: [this.pageInitialData.attachDocumentId],
              };
              this.copyAttachFile(attachParam);
            }
          }

          // 메일첨부 편집가능여부 : 없음
          if (has.call(this.pageInitialData, 'attachModify')) {
            // 본문수정가능여부 값이 null 인경우
            if (this.pageInitialData.attachModify === null || utils.isEmpty(this.pageInitialData.attachModify)) {
              this.isfileDisabled = true;
            } else if (this.pageInitialData.attachModify === true) {
              this.isfileDisabled = false;
            } else {
              this.isfileDisabled = true;
            }
          } else {
            this.isfileDisabled = false;
          }

          // Doc ID를 통한 파일첨부 세팅시 해당 파일 수정가능여부 .
          if (has.call(this.pageInitialData, 'transFileModify')) {
            // 본문수정가능여부 값이 null 인경우
            if (this.pageInitialData.transFileModify === null || utils.isEmpty(this.pageInitialData.transFileModify)) {
              this.isTransFileModify = true;
            } else if (this.pageInitialData.transFileModify === true) {
              this.isTransFileModify = false;
            } else {
              this.isTransFileModify = true;
            }
          } else {
            this.isTransFileModify = true;
          }

          // if (has.call(this.pageInitialData, 'objTemplate')) {
          if (!utils.isEmpty(this.pageInitialData.objTemplate)) {
            const { objTemplate } = this.pageInitialData;
            this.selectTemplate(objTemplate);
          } else if (utils.isEmpty(this.pageInitialData.mailContents) === false) {
            if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
              this.$refs.tuiEditor.setContent(this.pageInitialData.mailContents);
            } else {
              this.$refs.tuiViewer.editorViewer.setValue(this.pageInitialData.mailContents);
            }
          }
          // 본문수정가능여부 (디폴트 : 변경불가, Null인 경우 디폴트 값으로 셋팅)
          if (has.call(this.pageInitialData, 'contentsModify')) {
            // 본문수정가능여부 값이 null 인경우
            if (this.pageInitialData.contentsModify === null || utils.isEmpty(this.pageInitialData.contentsModify)) this.isEditorViewerMode = true;
            else if (this.pageInitialData.contentsModify === true) this.isEditorViewerMode = false;
            else this.isEditorViewerMode = true;
          } else {
            this.isEditorViewerMode = false;
          }

          // 예약메일인 경우
          if (this.pageInitialData.emailReservationYn === 'Y') {
            const reservationDateTime = utils.dateformatToServer(this.pageInitialData.emailStartDTM);
            this.rsvSendCheck = true;
            this.rsvSendDate = reservationDateTime.substring(0, 8);
            this.rsvSendTime = { HH: reservationDateTime.substr(8, 2), mm: reservationDateTime.substr(10, 2) };
          }
        }
      }
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    setParamList(count, gubunCode, email, userId) {
      let receiptTypeCode = '';
      if (gubunCode > 0) {
        receiptTypeCode = this.codes.COD_EMAIL_RECP_USR_TYPE[gubunCode].key;
      }

      let dataParams = '';
      dataParams = {
        emailUid: '',
        receiptUserEmail: email || '',
        emailReceiptUserOrder: _.toNumber(count),
        emailReceiptUserTypeCode: receiptTypeCode || '',
        emailReceiptUserId: userId || '',
        emailReceiptStatusCode: 'UNOPEN',
      };
      return dataParams;
    },
    copyAttachFile(objParams) {
      http.request(this.contextPageId, 'DTS_CMZ_00085', {
        data: objParams,
      }).then(res => {
        this.newDococumentId = res.data.attachDocumentId;
        // this.$refs.fileAttacher.searchAttachedFileInfoByDocId(res.data.attachDocumentId);
        this.attachDocumentId = res.data.attachDocumentId;
      }).catch(error => {
        console.log(error);
      });
    },
    selectTemplate(objTemplate) {
      if (objTemplate == undefined || objTemplate === '') return;
      http.request(this.contextPageId, 'DTS_CMZ_00075', {
        path: {
          'template-id': objTemplate.templateId,
          'site-id': objTemplate.siteId,
        },
        data: objTemplate,
      }).then(res => {
        // set WebEditorContents
        if (utils.isEmpty(res.data.sendTmpltCntn) === false) {
          this.isWebEditorContentsHtml = true;
          let tempContent = '';
          if (utils.isEmpty(this.pageInitialData.mailContents) === false) {
            tempContent = `${this.pageInitialData.mailContents}\r\n`
              + `<br><br>\r\n${
                res.data.sendTmpltCntn}`;
          } else {
            tempContent = res.data.sendTmpltCntn;
          }
          if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
            this.$refs.tuiEditor.setHtml(tempContent);
          } else {
            this.$refs.tuiViewer.editorViewer.setHtml(tempContent);
          }
        } else if (utils.isEmpty(this.pageInitialData.mailContents) === false) {
          if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
            this.$refs.tuiEditor.setContent(this.pageInitialData.mailContents);
          } else {
            this.$refs.tuiViewer.editorViewer.setValue(this.pageInitialData.mailContents);
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onClose() {
      console.log('onConfirm');
    },
    onSelectedUser(selectedUser) {
      if (!utils.isEmpty(selectedUser)) {
        // '${userName}/${departmentName}/${companyName} [${email}]',
        if (selectedUser.dsplLngId === this.$store.getters.userInfo.langId) {
          this.selectedUser.userName = `${selectedUser.userName}`;
          this.selectedUser.departmentName = `${selectedUser.departmentName}`;
          this.selectedUser.companyName = `${selectedUser.companyName}`;
        } else {
          this.selectedUser.userName = `${selectedUser.userGlobalName}`;
          this.selectedUser.departmentName = `${selectedUser.departmentEnglishName}`;
          this.selectedUser.companyName = `${selectedUser.companyEnglishName}`;
        }
        this.selectedUser.email = `${selectedUser.email}`;
        this.selectedUser.dsplLngId = `${selectedUser.dsplLngId}`;
        this.selectedUser.userId = `${selectedUser.userId}`;
        this.$refs.emailRecipients.addRecipient(this.selectedUser);
      } else {
        this.selectedUser.userName = '';
        this.selectedUser.departmentName = '';
        this.selectedUser.companyName = '';
        this.selectedUser.email = '';
        this.selectedUser.dsplLngId = '';
        this.selectedUser.userId = '';
      }
    },
    onSend(type) {
      // type : register 저장 0, tmpRegister 임시저장 T
      let emailSendStatusCode = type === 'register' ? '0' : 'T';
      const tempSave = this.pageInitialData === null ? null : this.pageInitialData.emailSendStatusCode;

      if (!this.isThisWindowPopup) {
        if (!utils.isEmpty(this.pageInitialData.mailList) && this.pageInitialData.emailSendStatusCode === 'T' && type !== 'register') {
          emailSendStatusCode = 'T';
        }
      }

      if (utils.isEmpty(this.emailTitle) === true) {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TITLE'));
        this.conFirm('error', msg, null);
        return;
      }

      // const fileAttachList = this.$refs.fileAttacher.getGridFileListInfo();
      const fileAttachList = this.$refs.fileAttacher.getAttachFileListInfo();

      let sendEpId = '';
      if (this.$store.getters.userInfo !== null) {
        if(this.$store.getters.userInfo.epid !== null){
          sendEpId = utils.trim(this.$store.getters.userInfo.epid);
        }else{
          sendEpId = utils.trim(this.$store.getters.userInfo.userId);
        }
      }else{
        return;
      }

      let dataParams = {};
      let count = 0;
      const mailDetailList = [];
      utils.forEach(this.$refs.emailRecipients.getRecptList(), data => {
        const mailData = this.setParamList(count,
          data.recipientType,
          data.email,
          data.userId);
        mailDetailList.push(mailData);
        count += 1;
      });

      // Workflow 연계관련 수신자ID list
      const recpUserList = [];
      utils.forEach(mailDetailList, item => {
        recpUserList.push(item.emailReceiptUserId);
      });

      if (mailDetailList.length < 1 && emailSendStatusCode !== 'T') {
        const msg = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RCPT_USR'));
        this.conFirm('error', msg, null);
        return;
      }

      // 예약발신 이전 날짜인 경우 메세지 출력
      if (this.rsvSendCheck === true) {
        //sonarcube codesmell 대응
        // if (!utils.isEmpty(this.pageInitialData) && this.pageInitialData.emailReservationYn === 'Y') {
          // const reservationDateTime = utils.dateformatToServer(this.pageInitialData.emailStartDTM);
          const currentDateTime = utils.now('YYYYMMDDHHmm');

          if (`${this.rsvSendDate}${this.rsvSendTime.HH}${this.rsvSendTime.mm}` < currentDateTime) {
            const msg = utils.strFormat(this.$t('MSG_ALT_CHK_DTM'), null);
            this.conFirm('warning', msg, null);
            return;
          }
        // } else {
        //   // const reservationDateTime = `${this.rsvSendDate}${this.rsvSendTime.HH}${this.rsvSendTime.mm}`;
        //   const currentDateTime = utils.now('YYYYMMDDHHmm');

        //   if (`${this.rsvSendDate}${this.rsvSendTime.HH}${this.rsvSendTime.mm}` < currentDateTime) {
        //     const msg = utils.strFormat(this.$t('MSG_ALT_CHK_DTM'), null);
        //     this.conFirm('warning', msg, null);
        //     return;
        //   }
        // }
      }

      let mContents = '';
      if (!this.isThisWindowPopup) {
        if (this.isWebEditorContentsHtml) {
          if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
            mContents = this.$refs.tuiEditor.getHtml();
          } else {
            mContents = this.$refs.tuiViewer.editorViewer.getHtml();
          }
        } else if (utils.isEqual(this.pageInitialData.Editor, 'Y') === true) {
          mContents = this.$refs.tuiEditor.getContent();
        } else {
          mContents = this.$refs.tuiViewer.editorViewer.getValue();
        }
        // 결재상신시 본문내용 사이즈 제한.
        this.maxContentsSize = utils.getConfigurationValue('CFG_CMZ_MAIL_CONT_LIMIT_SIZE');
        if (utils.getByte(mContents) > this.maxContentsSize) {
          const msg = utils.strFormat(this.$t('MSG_ALT_SIZE_LIMIT_EXCEEDED'), this.maxContentsSize);
          utils.messageBox('warning', msg);
          return;
        }
      } else {
        mContents = this.$refs.tuiEditor.getContent();
        // 본문내용 사이즈 제한.
        this.maxContentsSize = utils.getConfigurationValue('CFG_CMZ_MAIL_CONT_LIMIT_SIZE');
        if (utils.getByte(mContents) > this.maxContentsSize) {
          const msg = utils.strFormat(this.$t('MSG_ALT_SIZE_LIMIT_EXCEEDED'), this.maxContentsSize);
          utils.messageBox('warning', msg);
          return;
        }
      }

      // if (utils.trim(mContents.length) <= '11') {
      if (mContents.length <= 11) {
        const msg = utils.strFormat(this.$t('MSG_ALT_ROW_INPUT_CONTENT'));
        this.conFirm('error', msg, null);
        return;
      }

      // if (mailDetailList.length > 0) {
      if (!this.isThisWindowPopup) {
        const mailTemplateId = this.pageInitialData.objTemplate === undefined ? null : this.pageInitialData.objTemplate.templateId;
        const tempEmailUid = this.pageInitialData.emailUid !== null ? this.pageInitialData.emailUid : '';
        dataParams = {
          emailUid: tempEmailUid,
          connectionEmailId: '',
          emailTypeCode: 'PERSONAL',
          emailTitle: this.emailTitle || '',
          emailContent: mContents,
          epId: sendEpId || '',
          emailSendStatusCode,
          attachDocId: this.newDococumentId || '',
          emailReceiptUsers: mailDetailList,
          attachFiles: fileAttachList,
          sendTemplateId: mailTemplateId,
          rsvSendCheck: this.rsvSendCheck,
          rsvSendDate: utils.dateformatToServer(this.rsvSendDate),
          rsvSendTime: `${this.rsvSendTime.HH}${this.rsvSendTime.mm}00`,
          mailSendType: tempSave, // N : New
          receiptUserList: recpUserList,
        };
      } else {
        dataParams = {
          emailUid: null,
          connectionEmailId: '',
          emailTypeCode: 'PERSONAL',
          emailTitle: this.emailTitle || '',
          emailContent: mContents,
          epId: sendEpId || '',
          emailSendStatusCode,
          attachDocId: this.newDococumentId || '',
          emailReceiptUsers: mailDetailList,
          attachFiles: fileAttachList,
          sendTemplateId: null,
          rsvSendCheck: this.rsvSendCheck,
          rsvSendDate: utils.dateformatToServer(this.rsvSendDate),
          rsvSendTime: `${this.rsvSendTime.HH}${this.rsvSendTime.mm}00`,
          mailSendType: tempSave, // N : New
          receiptUserList: recpUserList,
        };
      }
      // }

      // sonarcube codesmell 대응
      // if (dataParams) {
        const mailAlertType = emailSendStatusCode === '0' ? this.$t('MSG_ALT_RSV_SEND') : this.$t('MSG_ALT_PRSS_TMP_SAVE');
        utils.messageBox('confirm', mailAlertType, null, () => {
          http.request(this.contextPageId, 'DTS_CMM_00003', {
            data: dataParams,
          }).then(res => {
            if (utils.isEqual(res.data.resultCode, '1') === true) {
              if (this.isThisWindowPopup) {
                window.CLOSE_SILIENTLY = true;
                window.close();
              } else {
                this.closePagePopup(true);
              }
            } else {
              this.conFirm('error', this.$t('MSG_ALT_SEND_MAIL_ERROR'), null);
            }
          }).catch(error => {
            console.log(error);
          });
        });
      // } else {
      //   this.conFirm('error', this.$t('MSG_ALT_SAV_NO_DATA'), null);
      // }
    },
    onCancel() {
      if (this.isThisWindowPopup) {
        window.CLOSE_SILIENTLY = true;
        window.close();
      } else {
        this.closePagePopup(true);
      }
    },
    onCheck() {
      const sessionLangId = this.$store.getters.userInfo.langId;
      if (this.writeTomeCheck === true) {
        const uName = sessionLangId === 'ko' ? utils.trim(this.$store.getters.userInfo.userName) : utils.trim(this.$store.getters.userInfo.userGlobalName);
        const mail = utils.trim(this.$store.getters.userInfo.email);
        const copanyName = sessionLangId === 'ko' ? utils.trim(this.$store.getters.userInfo.companyName) : utils.trim(this.$store.getters.userInfo.companyEnglishName);
        const deptName = sessionLangId === 'ko' ? utils.trim(this.$store.getters.userInfo.departmentName) : utils.trim(this.$store.getters.userInfo.departmentEnglishName);
        const userId = utils.trim(this.$store.getters.userInfo.userId);
        const userData = {
          userName: uName || '',
          email: mail || '',
          companyName: copanyName || '',
          departmentName: deptName || '',
          userId: userId || '',
        };
        this.$refs.emailRecipients.addRecipient(userData);
      }
    },
    onConfirmDatePicker(dateObj) {
      this.rsvSendDate = dateObj;
    },
    onReservationCheck() {
      if (this.rsvSendCheck === false) {
        this.$refs.rsvSendDate.disabled = false;
        this.$refs.rsvSendTime.disabled = false;
      }
    },
  },
};
</script>
<style scoped>
.comm_scr_wrap .row{background-color:#fff}
.col-xs, .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6,
.col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12{border:none}
</style>
<style>
.sui-checkbox__label {margin-right:0 !important}
</style>
